import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Sticky from 'react-stickynode';

import { msg } from 'api';
import SubscriptionsInfoBannerContainer from 'apps/subscriptions/containers/SubscriptionsInfoBannerContainer';
import SubscriptionsAdContainer from 'apps/subscriptions/containers/SubscriptionsAdContainer';
import SubscriptionsFopListContainer from 'apps/subscriptions/containers/SubscriptionsFopListContainer';
import DesktopCatalogueBreadcrumbs from 'apps/catalogue/components/breadcrumbs/DesktopCatalogueBreadcrumbs';
import ProductsPageFilterSidebar from 'apps/catalogue/components/sidebar/ProductsPageFilterSidebar';
import MobileCatalogueBreadcrumbs from 'apps/catalogue/components/breadcrumbs/MobileCatalogueBreadcrumbs';
import { getRegularsLink } from 'apps/catalogue/links';
import EnforceProductsPageLocation from 'apps/meta/components/EnforceProductsPageLocation';
import ErrorBoundary from 'utils/components/ErrorBoundary';
import ConditionalWrapper from 'utils/ConditionalWrapper';
import SubNavigation from 'apps/navigation/containers/SubNavigation';
import ResetButton from '../containers/ResetButton';

import { isBreadcrumbsWithNewUI } from 'lib/features';

import PageViewType from 'apps/analytics/components/PageViewType';
import PageStatistic from 'apps/analytics/components/PageStatistic';

import { determinePageStatistic } from 'apps/subscriptions/utils/SubscriptionsAnalytics';
import gtmPageTypes from 'apps/gtm/utils/gtmPageTypes';
import ImpressionsPageType from 'apps/gtm/containers/ImpressionsPageType';
import CataloguePageMetadata from 'apps/catalogue/components/meta/CataloguePageMetadata';
import { pageTypes } from 'apps/analytics';
import PageViewEvent from 'apps/analytics/containers/PageViewEvent';

export default class SubscriptionsPage extends Component {
  static propTypes = {
    basePath: PropTypes.string.isRequired,
    enableReset: PropTypes.bool,
    isStickySidebarEnabled: PropTypes.bool,
    landingPage: PropTypes.object,
    pageType: PropTypes.string.isRequired,
    pageUrl: PropTypes.string.isRequired,
    productsPage: PropTypes.object,
    routeString: PropTypes.string.isRequired,
  };

  // TODO temporary fix for search redirects issue
  shouldComponentUpdate(nextProps) {
    return !!nextProps.productsPage;
  }

  // eslint-disable-next-line max-lines-per-function
  render() {
    const {
      basePath,
      betaFeatures,
      enableReset,
      isStickySidebarEnabled,
      landingPage,
      pageType,
      pageUrl,
      productsPage,
      routeString,
    } = this.props;

    // TODO temporary fix for search redirects issue
    if (!productsPage) {
      return null;
    }

    const { pageParameters } = productsPage;
    const subcategories = get(productsPage, 'navWithFilters.subcategories');

    return (
      <div className="subs-landingPage clearfix">
        <PageViewEvent eventData={{ pageType: pageTypes.SUBSCRIPTIONS }} />
        <PageViewType pageType={pageType} />
        <ImpressionsPageType pageType={gtmPageTypes.Subscriptions} />
        <EnforceProductsPageLocation
          href={getRegularsLink(pageParameters, basePath, true)}
          pageParameters={pageParameters}
          routeString={routeString}
        />
        <CataloguePageMetadata
          basePath={basePath}
          pageParameters={pageParameters}
          subcategories={subcategories}
        />
        <PageStatistic field="SUBS_FEATURED_CATEGORY" value={determinePageStatistic(landingPage)} />
        <ErrorBoundary>
          <div className="sidebar">
            <ConditionalWrapper
              condition={isStickySidebarEnabled}
              wrapper={children => (
                <Sticky
                  top=".hd-header"
                  bottomBoundary="#main-content"
                  activeClass="gn-sticky-sidebar--active"
                  enableTransforms={false}
                  innerZ={21}
                >
                  {children}
                </Sticky>
              )}
            >
              <div>
                {enableReset && <ResetButton />}
                <SubNavigation
                  linksRoot={pageUrl}
                  productsPage={productsPage}
                  hideBrandBanners
                  forceHidePromo
                />
                <ProductsPageFilterSidebar
                  basePath={basePath}
                  filters={productsPage.navWithFilters.filters}
                  location={pageUrl}
                  mobileRefineByOpened={false}
                  pageParameters={pageParameters}
                  routeString={routeString}
                />
              </div>
            </ConditionalWrapper>
          </div>
          <div className="main-column">
            <header className="subL-header">
              <DesktopCatalogueBreadcrumbs
                baseName={msg.subscriptions.displayName}
                baseNameNewUI="Regulars"
                basePath={pageUrl}
                pageParameters={pageParameters}
                withNewUI={isBreadcrumbsWithNewUI(betaFeatures)}
              />
              <div className="catHeaderBar">
                <MobileCatalogueBreadcrumbs
                  baseName={msg.subscriptions.displayName}
                  categories={pageParameters.category}
                  isBorderHidden
                />
              </div>
              <SubscriptionsInfoBannerContainer routeString={routeString} />
              <SubscriptionsAdContainer routeString={routeString} />
            </header>
            <section>
              <SubscriptionsFopListContainer routeString={routeString} />
            </section>
          </div>
        </ErrorBoundary>
      </div>
    );
  }
}
